import PageComponent from '../../common/component/page-component';


class ApplicationNav extends PageComponent {

	constructor({element, root, currentClass = 'current'}) {
		super({element: element, root: root});
		this.currentClass = currentClass;
	}


	prepare() {
		const sectionElements = this.element.querySelectorAll(this.dataSelector('applicationNavItem'));
		this.currentId = 0;
		this.sections = new Map();
		for (const sectionElement of sectionElements) {
			const id = String(this.dataAttr(sectionElement).get('applicationNavItem'));
			this.sections.set(id, sectionElement);
			if (this.classList(sectionElement).contains(this.currentClass)) {
				this.currentId = id;
			}
		}
	}


	clear() {
		this.sections.clear();
	}


	switchTo(newId) {
		return new Promise((resolve) => {
			const current = this.sections.get(this.currentId);
			const next = this.sections.get(newId);
			const height = Math.max(current.getBoundingClientRect().height, next.getBoundingClientRect().height);
			this.element.style.height = height + 'px';
			this.classList(current).remove(this.currentClass);
			this.classList(next).add(this.currentClass);
			this.onTransitionEnd(next).then(() => {
				this.element.style.removeProperty('height');
				this.currentId = newId;
				resolve();
			});
		});
	}

}


export default ApplicationNav;
